import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessCardService } from '@services';
import { ToastrService } from 'ngx-toastr';

export const resolveGuard: CanActivateFn = (route, state) => {
  const businessCardService: BusinessCardService = inject(BusinessCardService);
  const toast: ToastrService = inject(ToastrService);
  const router: Router = inject(Router);
  businessCardService.getOriginalUrl(route.params.nanoid || '').subscribe({
    next: (res) => {
      if (res.status) {
        router.navigateByUrl(res.data.originalUrl);
      }
    },
    error: (err) => {
      toast.error(err);
    },
  });
  return true;
};
